/**
 * Accounts UI components registered globally, keyed by tag name.
 * Components used only within this applet, such as the account editor,
 * are imported directly where needed and deliberately not registered here.
 */
export default {
}